import { render, staticRenderFns } from "./DashboardOperations.vue?vue&type=template&id=e83d8c12&scoped=true"
import script from "./DashboardOperations.vue?vue&type=script&lang=js"
export * from "./DashboardOperations.vue?vue&type=script&lang=js"
import style0 from "./DashboardOperations.vue?vue&type=style&index=0&id=e83d8c12&prod&scoped=true&lang=css"
import style1 from "./DashboardOperations.vue?vue&type=style&index=1&id=e83d8c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83d8c12",
  null
  
)

export default component.exports